module.exports = __webpack_public_path__ + "img/nomin-logo-hands.56f5a2a8.png";